export default __webpack_public_path__ + "static/media/linkedin.80ec6867.svg";